export const getIsAuthenticated = ({ auth: isAuthenticated }) => isAuthenticated;
